"use strict";

exports.__esModule = true;
exports.formatDeviceName = formatDeviceName;
exports.formatDeviceNameAndTagName = formatDeviceNameAndTagName;
exports.formatDevicesAndGroupsList = formatDevicesAndGroupsList;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Device = require("../../../Device");
var _Theme = require("../../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Tag = _styledComponents["default"].span.withConfig({
  displayName: "device__Tag",
  componentId: "sc-15katip-0"
})(["color:", ";padding:2px;border-radius:3px;margin-right:2px;font-weight:bold;background:", ";"], (0, _Theme.val)("DefaultTagColor"), (0, _Theme.val)("DefaultTagBackground"));

/**
 * For the data value apply the formatting preferences to the value
 */
function formatDeviceName(deviceId, columnSettings, devices) {
  return (0, _Device.getDeviceName)(devices, deviceId);
}

/**
 * For the data value apply the formatting preferences to the value
 */
function formatDeviceNameAndTagName(devicesOrGroups, columnSettings, devicesMap) {
  // Had to do this because of filter. If a value is an object. This Fn should be able to handle
  if (!Array.isArray(devicesOrGroups)) {
    devicesOrGroups = [devicesOrGroups];
  }
  var tags = devicesOrGroups.filter(function (t) {
    return t.type === "TAG";
  }).map(function (item) {
    return item.value;
  });
  var others = devicesOrGroups.filter(function (t) {
    return t.type !== "TAG";
  }).map(function (item) {
    return devicesMap[item.value];
  });
  return [].concat(tags, [others.join(", ")]);
}
function formatDevicesAndGroupsList(devicesOrGroups, columnSettings, devices) {
  // Had to do this because of filter. If a value is an object. This Fn should be able to handle
  if (!Array.isArray(devicesOrGroups)) {
    devicesOrGroups = [devicesOrGroups];
  }
  var tags = devicesOrGroups.filter(function (t) {
    return t.type === "TAG";
  }).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(Tag, {
      key: item.value
    }, item.value);
  });
  var others = devicesOrGroups.filter(function (t) {
    return t.type !== "TAG";
  }).map(function (item) {
    return (0, _Device.getDeviceName)(devices, item.value);
  });
  return [].concat(tags, [others.join(", ")]);
}